class Comentario {
    constructor({
                    id = null,
                    taskId = null,
                    text = '',
                    author = 'anon',
                    createdAt = new Date().toISOString(),
                } = {}) {
        this.id = id
        this.taskId = taskId
        this.text = text
        this.author = author
        this.createdAt = createdAt
    }

    static from(api) {
        if (!api) return new Comentario()
        return new Comentario({
            id: api.id,
            taskId: api.tarea_id ?? null,
            text: api.comentario ?? '',
            author: api.autor_id ?? 'anon',
            createdAt: api.creado ?? new Date().toISOString(),
        })
    }

    toObject() {
        return {
            id: this.id ?? undefined,
            tarea_id: this.taskId,
            comentario: this.text,
            autor_id: this.author,
        }
    }
}

export default Comentario;